import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import React from 'react';
import { useObservable } from 'react-use-observable';
import chargebackService from 'v2/services/chargeback';

import ExportChargeback from './Export';
import { useStyles, TotalItem } from './styles';

const Totalizers = () => {
  const [totalItems] = useObservable(() => chargebackService.getTotalItems(), []);
  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);
  const [getTotalChargeback] = useObservable(() => chargebackService.getTotalChargeback(), []);

  const classes = useStyles();

  const chargebacksCount = `${totalItems} Chargeback${totalItems > 1 ? 's' : ''}`;

  if (isLoading) return null;

  return (
    <Grid id='chargebacks-totalizers' className={classes.gridContainer} container alignItems='center'>
      <Grid item>
        <ListItem>
          <TotalItem variant='body1'>{chargebacksCount}</TotalItem>
        </ListItem>
      </Grid>
      <Divider className={classes.divider} orientation='vertical' />
      <Grid>
        <ListItem>
          <TotalItem variant='body1'>
            <span>Total de Chargeback: </span>
            <ColoredFormattedNumber value={getTotalChargeback} format='BRL' />
            <Tooltip className={classes.tooltipIcon} title='Valor total das faturas em chargeback' placement='right-start'>
              <HelpOutlineIcon fontSize='small' />
            </Tooltip>
          </TotalItem>
        </ListItem>
      </Grid>
      <Divider className={classes.divider} orientation='vertical' />
      <Grid item className={classes.exportContainer}>
        <ExportChargeback />
      </Grid>
    </Grid>
  );
};

export default Totalizers;
